import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import DeletedMaterial from "./DeleteMaterial";
import UpdateMaterial from "./UpdateMaterial";

const server_backend = config.API_URL;

const Material = ({ username }) => {
    const [MaterialList, setMaterialList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [onMaterialID, setOnMaterialID] = useState(0);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");

    useEffect(() => {
        const getMaterial = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMaterialList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMaterial();
    }, []);

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModal = () => {
        setIsUpdating(false);
    }

    const getMaterial = async () => {
        try {
            const response = await axios.get(`${server_backend}/materials/list`, headers);

            if (response.data.RES_CODE === "00") {
                setMaterialList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterMaterial(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);

        if (filtersEnabled) {
            FilterMaterial();
        }
    };


    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterMaterial = async () => {
        try {
            const response = await axios.get(`${server_backend}/materials/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setMaterialList(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterMaterial();
        }
    }, [filterBy, filterStatus, filterValue]);

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                {!isUpdating ? (
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">Material List</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Material</a></li>
                                        <li className="breadcrumb-item active">Material List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <UpdateMaterial username={username} onMaterialID={onMaterialID} onClose={CloseModal} getMaterial={getMaterial} />
                )}

                {!isUpdating && (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card" id="tasksList">
                                <div className="card-header border-0">
                                    <div className="d-flex align-items-center">
                                        <h5 className="card-title mb-0 flex-grow-1">All Material</h5>
                                        <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                            <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                            </button>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <Link className="btn btn-danger add-btn" to="/create-material">
                                                <i className="ri-add-line align-bottom me-1"></i> Create
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {filtersEnabled && (
                                    <div className="card-body border border-dashed border-end-0 border-start-0">
                                        <div className="row g-3">
                                            <div className="col-4">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        name="choices-single-default"
                                                        disabled={!filtersEnabled}
                                                        value={filterBy}
                                                        onChange={handleFilterByChange}
                                                    >
                                                        <option value="">Filter by</option>
                                                        <option value="mat_ID">ID</option>
                                                        <option value="name">Name</option>
                                                        <option value="matt_ID">Material type</option>

                                                        <option value="unit">Unit</option>
                                                        <option value="price">Price</option>
                                                        <option value="purity">Purity</option>
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        data-choices
                                                        data-choices-search-false
                                                        name="choices-single-default"
                                                        id="idFilterStatus"
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterStatusChange}
                                                    >
                                                        <option value={0}>Filter status</option>
                                                        <option value={1}>ACTIVATED</option>
                                                        <option value={2}>DISABLED</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="search-box">
                                                    <input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder="Search for tasks or something..."
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterValueChange}
                                                    />
                                                    <i className="ri-search-line search-icon"></i>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                )}

                                <div className="card-body">
                                    <div
                                        className="table-responsive table-card mb-4"
                                        style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                                    >
                                        <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                            <thead className="table-light text-muted"> <tr> <th className="th-hover" onClick={() => handleColumnClick("mat_ID")}>ID</th> <th className="th-hover" onClick={() => handleColumnClick("name")}>Name</th> <th className="th-hover" onClick={() => handleColumnClick("name")}>Xero Item Code</th> <th className="th-hover" onClick={() => handleColumnClick("matt_ID")}>Material type </th> <th className="th-hover" onClick={() => handleColumnClick("price")}>Price </th> <th className="th-hover" onClick={() => handleColumnClick("purity")}>Purity</th> <th className="th-hover" onClick={() => handleColumnClick("status")}>Status</th> <th>Action</th> </tr> </thead>
                                            <tbody className="list form-check-all">
                                                {MaterialList.map((Material_L) => (
                                                    <tr key={Material_L.mat_ID}>
                                                        <th scope="row">
                                                            <div className="form-check">
                                                                {Material_L.mat_ID}
                                                            </div>
                                                        </th>

                                                        <td className="name">
                                                            <div className="d-flex align-items-center">
                                                                {/* Circle color */}
                                                                <span
                                                                    className="me-2"
                                                                    style={{
                                                                        width: "15px",
                                                                        height: "15px",
                                                                        backgroundColor: Material_L.color || "#cccccc",
                                                                        borderRadius: "50%",
                                                                        border: "1px solid #aaa",
                                                                        flexShrink: 0,
                                                                    }}
                                                                ></span>
                                                                {/* Name */}
                                                                <span>{Material_L.name}</span>
                                                            </div>
                                                        </td>


                                                        <td className="comment">{Material_L.comment}</td>
                                                        <td className="name">{Material_L.types_name}</td>
                                                        <td className="name">{`$ ${Material_L.price}`}</td>
                                                        <td className="name">{Material_L.purity}</td>
                                                        <td className="status">
                                                            <span
                                                                className={`${Material_L.status_name === "ACTIVATED"
                                                                    ? "badge badge-soft-success"
                                                                    : "badge badge-soft-danger"
                                                                    } text-uppercase`}
                                                            >
                                                                {Material_L.status_name}
                                                            </span>
                                                        </td>
                                                        <td className="due_date">
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item edit">
                                                                    <Link
                                                                        type="button"
                                                                        onClick={() => {
                                                                            ShowModalUpdate();
                                                                            setOnMaterialID(Material_L.mat_ID);
                                                                        }}
                                                                        className="text-primary d-inline-block edit-item-btn"
                                                                    >
                                                                        <i className="ri-pencil-fill fs-16"></i>
                                                                    </Link>
                                                                </li>
                                                                <li className="list-inline-item">
                                                                    <Link
                                                                        className="text-danger d-inline-block remove-item-btn"
                                                                        onClick={() => {
                                                                            DeletedMaterial(Material_L.mat_ID, username, getMaterial);
                                                                        }}
                                                                    >
                                                                        <i className="ri-delete-bin-5-fill fs-16"></i>
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                    </div>
                                    <div className="row g-0 text-center text-sm-start">
                                        <div className="col-sm-6">
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Material;
